import { render, staticRenderFns } from "./StaffTermlyReportList.vue?vue&type=template&id=1c59de78&scoped=true"
import script from "./StaffTermlyReportList.vue?vue&type=script&lang=js"
export * from "./StaffTermlyReportList.vue?vue&type=script&lang=js"
import style0 from "./StaffTermlyReportList.vue?vue&type=style&index=0&id=1c59de78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59de78",
  null
  
)

export default component.exports